import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';
import { FILTER_NAMES, DETAILING_FILTER_NAMES } from '../data';
import { FilterNames, FiltersData } from '../types';

interface FilterItem {
  value: string;
  label: string;
}

export const useAderenciaDetailsFilters = () => {
  const { setAderenciaPrecosState, setAderenciaDetailsBodyRequests, redeDetailing, ufDetailing, tipoLojaDetailing, produtoDetailing } =
    useAderenciaPrecosStore();

  const FILTERS = {
    REDE: redeDetailing,
    UF: ufDetailing,
    TIPO_LOJA: tipoLojaDetailing,
    PRODUTO: produtoDetailing,
  };

  const updateFilterState = (name: FilterNames, data: FiltersData) => {
    const prev = FILTERS[name];
    setAderenciaPrecosState(DETAILING_FILTER_NAMES[name], { ...prev, ...data });
  };

  const addFilterItem = (name: FilterNames, item: FilterItem) => {
    const prev = FILTERS[name];

    if (!prev?.value.includes(item.value)) {
      const value = [...prev?.value, item.value];
      const cache = [...(prev?.cache || []), item];

      updateFilterState(name, {
        value,
        cache,
      });

      setAderenciaDetailsBodyRequests(FILTER_NAMES[name], value);
    }
  };

  const removeFilterItem = (name: FilterNames, item: FilterItem) => {
    const prev = FILTERS[name];
    const value = prev?.value.filter(value => value !== item.value);
    const cache = prev?.cache?.filter(cache => cache.value !== item.value);

    updateFilterState(name, {
      value,
      cache,
    });

    setAderenciaDetailsBodyRequests(FILTER_NAMES[name], value);
  };

  const handleSelectAderenciaDetailingFilter = (name: FilterNames, item: FilterItem) => {
    const prev = FILTERS[name];
    if (prev?.value.includes(item.value)) {
      removeFilterItem(name, item);
    } else {
      addFilterItem(name, item);
    }
  };

  const handleCleanAderenciaDetailingFilter = (name: FilterNames) => {
    updateFilterState(name, { value: [], cache: [] });
    setAderenciaDetailsBodyRequests(FILTER_NAMES[name], []);
  };

  return {
    handleCleanAderenciaDetailingFilter,
    handleSelectAderenciaDetailingFilter,
  };
};
